import React from 'react'
import { ButtonSpinner } from './Spinner'
import { ButtonStyled, StyledProps } from './Button.styles'

export interface Props extends StyledProps {
  fullWidth?: boolean
  children: React.ReactNode
  loading?: boolean
}

type ButtonProps = Props & React.ButtonHTMLAttributes<HTMLButtonElement>

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ children, loading, ...props }: ButtonProps, ref) {
    return (
      <ButtonStyled {...props} ref={ref}>
        {children}
        {loading && <ButtonSpinner />}
      </ButtonStyled>
    )
  },
)

type LinkButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  Props & { loading?: never }

export const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  function LinkButton({ children, ...props }: LinkButtonProps, ref) {
    return (
      <ButtonStyled as='a' {...props} ref={ref}>
        {children}
      </ButtonStyled>
    )
  },
)

export default Button
